<button class="toggleButton" mat-icon-button fxShow="true" fxHide.gt-sm (click)="toggleNavbar()">
  <mat-icon>menu</mat-icon>
</button>
<div class="collapsed" [ngClass]="{ 'show': navbarOpen }">
  <nav>
    <ng-container *ngFor="let menu of (routeData$ | async).subMenu">
      <ng-container *ngIf="!menu.hideInMenu && (rolesOk(menu.needsRole) | async)">
        <ng-container *ngIf="menu.subMenu as mySubMenu;else noSubMenu">
          <app-nav-bar-menu-item #subMenuItem [basePath]="[menu.path]" [items]="mySubMenu"></app-nav-bar-menu-item>
          <a mat-button [matMenuTriggerFor]="subMenuItem.childMenu">{{menu.description}}
            <mat-icon>arrow_drop_down
            </mat-icon></a>
        </ng-container>

        <ng-template #noSubMenu>
          <a mat-button [routerLink]="menu.path">{{menu.description}}</a>
        </ng-template>
      </ng-container>
    </ng-container>
  </nav>
</div>
